module.exports = __webpack_public_path__ + "static/media/SnowMoon13n.1e5de37e.png";